module.exports = __webpack_public_path__ + "img/step_en.7d07e437.png";